import { Box, fade, Grid, makeStyles, useMediaQuery } from '@material-ui/core';
import { useEffect, useState, useRef } from 'react';
import { get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import ReactECharts from 'echarts-for-react';
import ChartButtons from './ChartButtons';
import { generateLineTypeChartData } from './helpers';
import Skeleton from '@material-ui/lab/Skeleton';
import {
  getCharts,
  updateCharts,
  CHART_TYPES,
} from '../../redux_store';
import theme from '../../config/theme';

const ANIMATION_DURATION = 800;

const useStyles = makeStyles((theme) => ({
  chartBox: {
    width: '100%',
    height: 336,
    border: `1px solid ${fade(theme.palette.common.black, 0.12)}`,
    borderRadius: theme.shape.borderRadius,
  },
  shimmer: {
    margin: theme.spacing(4, 0),
    width: '100%',
    height: 1000,
  },
}));

const Charts = () => {
  const { en } = useSelector((state) => state.i18n);
  const dispatch = useDispatch();
  const classes = useStyles();
  const { charts } = useSelector((state) => state.charts);
  const { metrics } = useSelector((state) => state.charts);
  const chartData = metrics?.chartData;
  const { isInfoPaneExpanded } = useSelector((state) => state.infoPane);
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  useEffect(() => {
    dispatch(getCharts());
  }, []);

  return (
    <Grid container spacing={4}>
      {!chartData && <Skeleton variant='rect' className={classes.shimmer} />}
      {chartData && charts && charts.map(({ key, chartType, chartDate }) => {
        const data = chartData ? generateLineTypeChartData(
          en.charts[key],
          get(chartData, key, []).map(({ name, value }) => ({
            value,
            name: en.charts[name],
          })),
          chartType,
        ) : {};
        return (
          <Grid
            style={{
              position: 'relative',
            }}
            item
            lg={isInfoPaneExpanded && isDesktop ? 12 : 6}
            md={12}
            xs={12}
            sm={12}
          >
            <ChartButtons
              chartType={chartType}
              chartDate={chartDate}
              setCharts={(newCharts) => dispatch(updateCharts(newCharts))}
              charts={charts}
              dataKey={key}
            />
            <Box className={classes.chartBox}>
              <UniversalChart
                data={data}
                chartType={chartType}
                key={`${key}-${chartType}`}
              />
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Charts;


const UniversalChart = ({ data, chartType }) => {
  const [canRender, setCanRender] = useState(false);
  const [animation, setAnimation] = useState(ANIMATION_DURATION);
  const chartRef = useRef(null);

  useEffect(() => {
    setCanRender(false);
    const timer = setTimeout(() => {
      setCanRender(true);
      setTimeout(() => {
        setAnimation(0);
      }, ANIMATION_DURATION - 10);
    }, 50);

    return () => {
      clearTimeout(timer);
      if (chartRef.current && chartRef.current.getEchartsInstance) {
        try {
          chartRef.current.getEchartsInstance().dispose();
        } catch (e) {}
      }
    };
  }, []);

  const height = chartType === CHART_TYPES.PIE ? 400 : 330;

  const chartOption = {
    ...data,
    animationDuration: animation,
  };

  return (
    <ReactECharts
      ref={chartRef}
      style={{ height }}
      opts={{ renderer: 'svg' }}
      option={canRender ? chartOption : {}}
      notMerge={true}
      lazyUpdate={false}
    />
  );
};

